import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import toast from "../helpers/toast";
import Httpconfig from "../helpers/HttpconfigDiagnostics";
import Constant from "../../constants";
import { Multiselect } from "multiselect-react-dropdown";
import { Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import DiagnosisHeader from "./DiagnosisHeader";
import DiagnosisMenu from "./DiagnosisMenu";
import * as SecureLS from "secure-ls";
import constants from "../../constants";
var ls = new SecureLS({
    encodingType: "aes",
    encryptionSecret: "medleymed",
});
const moment = require("moment");

export default class DiagnosticsBanners extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fields: {},
            errors: {},
            coupon_data: "",

            options: [],
            userarray: [],
            customersarray: [],
            selectedList: {},
            selectedValue: [],
            diagnosisId: "",
            banner_images: [],
            bannerImagePreviews: [],
            isSubmitting: false,
        };
    }

    //  Set setting the start tinme
    setStartTimeOnChange = (value) => {
        this.setState({ start_date: value });
    };

    //  for setting the end time
    setEndTimeOnChange = (value) => {
        this.setState({ end_date: value });
    };

    // To get detais after first render
    componentDidMount = () => {
        const { handle } = this.props.match.params;
        let userData = ls.get("diagnosticsuserObj");
        if (userData && userData !== "") {
            this.setState({ diagnosisId: userData.diagnosis_id }, () => {
                if (handle) {
                    this.getBannerInfo(handle);
                }
            });
        } else {
            window.location.href = "/diagnostics/login";
        }
        this.fetchusersdata();
    };

    // For getting the users data
    fetchusersdata() {
        Httpconfig.httptokenget(
            Constant.siteurl + "api/Patients/findPatientName"
        ).then((response) => {
            this.setState({
                options: response.data,
                userarray: response.data,
            });
        });
    }

    //  For on select

    onSelect = (selectedListdata, selectedItem) => {
        this.setState({
            selectedList: selectedListdata.map((x) => x.id),
        });
    };

    //  For on remove
    onRemove = (deselectedList, removedItem) => {
        this.setState({
            selectedList: deselectedList.map((x) => x.id),
        });
    };

    // When value changes of the fields
    handleChange = (field, event) => {
        let fields = this.state.fields;
        // For category dropdown, do not force uppercase
        if (field === "category") {
            fields[field] = event.target.value;
        } else {
            fields[field] = event.target.value.toUpperCase();
        }
        this.setState({ fields });
    }
    // Helper to convert File to base64
    convertFileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
            reader.readAsDataURL(file);
        });
    };

    // Modified image handler to store base64
    handleBannerImagesChange = async (event) => {
        const newFiles = Array.from(event.target.files);
        const banner_images = [];
        for (let file of newFiles) {
            const base64 = await this.convertFileToBase64(file);
            banner_images.push({ file, base64, name: file.name });
        }
        this.setState({
            banner_images: [...this.state.banner_images, ...banner_images],
            bannerImagePreviews: [
                ...this.state.bannerImagePreviews,
                ...banner_images.map(img => img.base64)
            ]
        });
    };

    removeBannerImage = (idx) => {
        const banner_images = [...this.state.banner_images];
        const bannerImagePreviews = [...this.state.bannerImagePreviews];
        banner_images.splice(idx, 1);
        bannerImagePreviews.splice(idx, 1);
        this.setState({ banner_images, bannerImagePreviews });
    };



    // create or update
    checkSubmit(event) {
        event.preventDefault();
        if (this.state.isSubmitting) return;
        const { handle } = this.props.match.params;
        if (this.handleValidation() && handle) {
            this.setState({ isSubmitting: true }, () => this.updateBanner(event));
        } else if (this.handleValidation() && handle === undefined) {
            this.setState({ isSubmitting: true }, () => this.createBanner(event));
        } else {
            console.log("Form has errors:",event);
            console.log(this.state.errors);
            toast.warn("Form has errors.");
        }
    }

    // creates new controller
    createBanner = async (event) => {
        event.preventDefault();
        const { fields, banner_images, diagnosisId } = this.state;
        const images = banner_images.map((img, idx) => ({
            image_url: img.base64,
            alt_text: img.name,
            sort_order: idx + 1
        }));

        const payload = {
            module_id: 3,
            module_type: "diagnostics",
            retailer_id: diagnosisId,
            banner_name: fields["banner_name"],
            description: fields["description"] || "",
            position: fields["category"] || "",
            start_date: moment(this.state.start_date).format("YYYY-MM-DD"),
            end_date: moment(this.state.end_date).format("YYYY-MM-DD"),
            redirection_tags: fields["redirection_tags"] || "",
            approval_status: "pending",
            status: fields["status"] === "ACTIVE" ? "active" : "inactive",
            created_by: 1,
            images
        };

        Httpconfig.httptokenpost(constants.siteurl+"api/OM/Banners/", payload)
            .then((response) => {
                toast.success("Banner Created Successfully");
                console.log("Banner Created Successfully", payload);
                setTimeout(() => this.props.history.push("/diagnostics/ViewDiagnosticsBanners"), 1000);
            })
            .catch((error) => {
                toast.error("Banner creation failed");
            })
            .finally(() => {
                this.setState({ isSubmitting: false });
            });
    };

    // updates controller
    updateBanner = async (event) => {
        event.preventDefault();
        const { fields, banner_images, diagnosisId } = this.state;
        const { handle } = this.props.match.params;
        const images = banner_images.map((img, idx) => ({
            image_url: img.base64,
            alt_text: img.name,
            sort_order: idx + 1
        }));

        const payload = {
            module_id: 3,
            module_type: "diagnostics",
            retailer_id: diagnosisId,
            banner_name: fields["banner_name"],
            description: fields["description"] || "",
            position: fields["category"] || "",
            start_date: moment(this.state.start_date).format("YYYY-MM-DD"),
            end_date: moment(this.state.end_date).format("YYYY-MM-DD"),
            redirection_tags: fields["redirection_tags"] || "",
            approval_status: "pending",
            status: fields["status"] === "ACTIVE" ? "active" : "inactive",
            created_by: 1,
            images
        };

        Httpconfig.httptokenput(constants.siteurl+`api/OM/Banners/${handle}`, payload)
            .then((response) => {
                toast.success("Banner Updated Successfully");
                setTimeout(() => this.props.history.push("/diagnostics/ViewDiagnosticsBanners"), 1000);
            })
            .catch((error) => {
                toast.error("Banner update failed");
            })
            .finally(() => {
                this.setState({ isSubmitting: false });
            });
    };

    //  For validating the fields

    handleValidation() {
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;

        // Banner Name
        if (!fields["banner_name"]) {
            formIsValid = false;
            errors["banner_name"] = "Banner name cannot be empty";
        } else if (fields["banner_name"].trim().length < 3) {
            formIsValid = false;
            errors["banner_name"] = "Banner name must be at least 3 characters";
        } else if (!/^[@ _ a-zA-Z0-9- ]*$/.exec(fields["banner_name"])) {
            formIsValid = false;
            errors["banner_name"] = "Banner name contains invalid characters";
        }

        // Category/Position
        if (!fields["category"]) {
            formIsValid = false;
            errors["category"] = "Category/Position cannot be empty";
        }

        // Start Date
        if (!this.state.start_date) {
            formIsValid = false;
            errors["start_date"] = "Start Date cannot be empty";
        }

        // End Date
        if (!this.state.end_date) {
            formIsValid = false;
            errors["end_date"] = "End Date cannot be empty";
        }

        // Date Comparison - Start date should be less than or equal to End date
        if (this.state.start_date && this.state.end_date) {
            const startDate = new Date(this.state.start_date);
            const endDate = new Date(this.state.end_date);
            
            // Reset time to midnight for accurate date-only comparison
            startDate.setHours(0, 0, 0, 0);
            endDate.setHours(0, 0, 0, 0);
            
            if (startDate > endDate) {
                formIsValid = false;
                errors["end_date"] = "End date must be greater than or equal to start date";
            }
        }

        // Check if dates are in the past (optional - uncomment if needed)
        // const today = new Date();
        // today.setHours(0, 0, 0, 0);
        // if (this.state.start_date) {
        //     const startDate = new Date(this.state.start_date);
        //     startDate.setHours(0, 0, 0, 0);
        //     if (startDate < today) {
        //         formIsValid = false;
        //         errors["start_date"] = "Start date cannot be in the past";
        //     }
        // }

        // Redirection Tags
        if (!fields["redirection_tags"]) {
            formIsValid = false;
            errors["redirection_tags"] = "Redirection tags cannot be empty";
        }

        // Status
        if (!fields["status"]) {
            formIsValid = false;
            errors["status"] = "Status cannot be empty";
        }

        // Images
        if (this.state.banner_images.length === 0) {
            formIsValid = false;
            errors["banner_images"] = "Please upload at least one banner image";
        }

        // Description (optional but recommended)
        if (fields["description"] && fields["description"].length > 500) {
            formIsValid = false;
            errors["description"] = "Description cannot exceed 500 characters";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    getBannerInfo = (banner_id) => {
        const payload = {
            module_type: "diagnostics",
            status: '',
            search: "",
            page: 1,
            limit: 1,
            entity_id: this.state.diagnosisId,
            banner_id: banner_id
        };
        Httpconfig.httptokenpost(constants.siteurl+"api/OM/Banners/list", payload)
            .then((response) => {
                const data = response.data.data && response.data.data[0];
                if (data) {
                    // Set fields
                    this.setState({
                        fields: {
                            banner_name: data.banner_name,
                            description: data.description || "",
                            category: data.position,
                            redirection_tags: data.redirection_tags,
                            status: data.status === "active" ? "ACTIVE" : "INACTIVE"
                        },
                        start_date: new Date(data.start_date),
                        end_date: new Date(data.end_date),
                        banner_images: data.images.map((img, idx) => ({
                            file: null,
                            base64: img.image_url,
                            name: img.alt_text || `Banner ${idx + 1}`
                        })),
                        bannerImagePreviews: data.images.map(img => img.image_url)
                    });
                }
            })
            .catch((error) => {
                toast.error("Failed to fetch banner info");
            });
    };

    render() {
        const { fields, errors, coupon_data } = this.state;

        return (
            <main id="main">
                <DiagnosisHeader />
                <DiagnosisMenu />
                <section id="main_dashboard" className="col-md-offset-2" style={{ marginLeft: '180px' }}>
                    <div className="container-fluid" id="main_front">
                        <div className="row">
                            <div className="col-md-10">
                                <div className="dash-section">
                                    <div className="section-header">
                                        <ol className="breadcrumb">
                                            <li className="active">
                                                <Link to="/diagnostics/diagnosisDashboard"> Dashboard</Link> &gt;
                                                <a> Banners </a>
                                            </li>
                                        </ol>
                                    </div>
                                </div>

                                <section id="CMS_tab">
                                    <div className="CMS_content create_calender">
                                        <div className="container">
                                            <div className="row">
                                                <div className="tab-header">
                                                    <h3>{this.props.match.params.handle ? "Update Banner Management" : "Create Banner Management"}</h3>
                                                </div>
                                                <div id="reg_form">
                                                    <form onSubmit={this.checkSubmit.bind(this)}>
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <div className="form-group ">
                                                                    <label htmlFor="customRadio2" className="custom-control-label">
                                                                        Banner Name
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        name="banner_name"
                                                                        value={this.state.fields["banner_name"] || ""}
                                                                        onChange={this.handleChange.bind(this, "banner_name")}
                                                                        className="form-control"
                                                                        placeholder="Banner Name"
                                                                    />
                                                                    <span className="cRed">
                                                                        {this.state.errors["banner_name"]}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label htmlFor="category" className="custom-control-label">
                                                                        Category
                                                                    </label>
                                                                    <select
                                                                        id="category"
                                                                        name="category"
                                                                        className="form-control"
                                                                        value={this.state.fields["category"] || ""}
                                                                        onChange={this.handleChange.bind(this, "category")}
                                                                    >
                                                                        <option value="" disabled>
                                                                            Select Category
                                                                        </option>
                                                                        <option value="Header">Header</option>
                                                                        <option value="Footer">Footer</option>
                                                                        <option value="Middle">Middle</option>
                                                                        <option value="Tests">Tests</option>
                                                                        <option value="Packages">Packages</option>
                                                                        <option value="Latest Offers">Latest Offers</option>
                                                                    </select>
                                                                    <span className="cRed">
                                                                        {this.state.errors["category"]}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <div className="form-group ">
                                                                    <label
                                                                        htmlFor="customRadio2"
                                                                        className="custom-control-label"
                                                                    >
                                                                        Start Date
                                                                    </label>
                                                                    <DatePicker
                                                                        name="start_date"
                                                                        autoComplete="off"
                                                                        className="dateInput"
                                                                        placeholderText="Start Date"
                                                                        popperPlacement="bottom"
                                                                        minDate={new Date()}
                                                                        popperModifiers={{
                                                                            flip: {
                                                                                behavior: ["bottom"],
                                                                            },
                                                                        }}
                                                                        selected={this.state.start_date}
                                                                        onChange={this.setStartTimeOnChange}
                                                                        dateFormat="yyyy-MM-d"
                                                                        calendarIcon
                                                                        showMonthDropdown
                                                                        adjustDateOnChange
                                                                    />

                                                                    <span className="cRed">
                                                                        {this.state.errors["start_date"]}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-4">
                                                                <div className="form-group ">
                                                                    <label
                                                                        htmlFor="customRadio2"
                                                                        className="custom-control-label"
                                                                    >
                                                                        End Date
                                                                    </label>
                                                                    <DatePicker
                                                                        name="end_date"
                                                                        autoComplete="off"
                                                                        className="dateInput"
                                                                        placeholderText="End Date"
                                                                        popperPlacement="bottom"
                                                                        minDate={new Date()}
                                                                        popperModifiers={{
                                                                            flip: {
                                                                                behavior: ["bottom"],
                                                                            },
                                                                        }}
                                                                        selected={this.state.end_date}
                                                                        onChange={this.setEndTimeOnChange}
                                                                        dateFormat="yyyy-MM-d"
                                                                        calendarIcon
                                                                        showMonthDropdown
                                                                        adjustDateOnChange
                                                                    />

                                                                    <span className="cRed">
                                                                        {this.state.errors["end_date"]}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label htmlFor="redirection_tags" className="custom-control-label">
                                                                        Redirection Tags
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        name="redirection_tags"
                                                                        value={this.state.fields["redirection_tags"] || ""}
                                                                        onChange={this.handleChange.bind(this, "redirection_tags")}
                                                                        className="form-control"
                                                                        placeholder="Enter tags like category, tests"
                                                                    />
                                                                    <span className="cRed">
                                                                        {this.state.errors["redirection_tags"]}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label htmlFor="banner_images" className="custom-control-label">
                                                                        Upload Banner Image
                                                                    </label>
                                                                    <input
                                                                        type="file"
                                                                        name="banner_images"
                                                                        className="form-control"
                                                                        multiple
                                                                        accept="image/*"
                                                                        onChange={e => this.handleBannerImagesChange(e)}
                                                                    />
                                                                    <span className="cRed">
                                                                        {this.state.errors["banner_images"]}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {this.state.bannerImagePreviews && this.state.bannerImagePreviews.length > 0 && (
                                                            <div className="image-preview-list" style={{ marginTop: '10px' }}>
                                                                <label style={{ fontWeight: 'bold' }}>Image Preview:</label>
                                                                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                                                    {this.state.bannerImagePreviews.map((src, idx) => (
                                                                        <div key={idx} style={{ textAlign: 'center', position: 'relative' }}>
                                                                            <img
                                                                                src={src}
                                                                                alt={`preview-${idx}`}
                                                                                style={{ width: 80, height: 80, objectFit: 'cover', border: '1px solid #ccc', borderRadius: 4 }}
                                                                            />
                                                                            <div style={{ fontSize: 12, marginTop: 2 }}>
                                                                                {this.state.banner_images[idx]?.name}
                                                                            </div>
                                                                            <button
                                                                                type="button"
                                                                                onClick={() => this.removeBannerImage(idx)}
                                                                                style={{
                                                                                    position: 'absolute',
                                                                                    top: 0,
                                                                                    right: 0,
                                                                                    background: 'rgba(255,255,255,0.8)',
                                                                                    border: 'none',
                                                                                    borderRadius: '50%',
                                                                                    width: 22,
                                                                                    height: 22,
                                                                                    cursor: 'pointer',
                                                                                    color: '#d00',
                                                                                    fontWeight: 'bold',
                                                                                    lineHeight: '18px',
                                                                                    padding: 0
                                                                                }}
                                                                                title="Remove"
                                                                            >
                                                                                ×
                                                                            </button>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        )}

                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <div className="form-group ">
                                                                    <label className="custom-control-label">
                                                                        Status
                                                                    </label>
                                                                    <div
                                                                        className="custom-control custom-radio"
                                                                        onChange={this.handleChange.bind(this, "status")}
                                                                    >
                                                                        <input
                                                                            type="radio"
                                                                            value="ACTIVE"
                                                                            checked={this.state.fields["status"] === "ACTIVE"}
                                                                            name="status"
                                                                        /> Active &nbsp;&nbsp;&nbsp;
                                                                        <input
                                                                            type="radio"
                                                                            value="INACTIVE"
                                                                            checked={this.state.fields["status"] === "INACTIVE"}
                                                                            name="status"
                                                                        /> Inactive
                                                                    </div>
                                                                    <span className="cRed">
                                                                        {this.state.errors["status"]}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="form-group col-md-12">
                                                                <button
                                                                    type="submit"
                                                                    className="btn  btn-primary save_btn"
                                                                    disabled={this.state.isSubmitting}
                                                                >
                                                                    {this.state.isSubmitting ? "Saving..." : "Save Banner"}
                                                                </button>{" "}
                                                                &nbsp;
                                                                <Link
                                                                    to="/diagnostics/ViewDiagnosticsBanners"
                                                                    className="cancel_btn"
                                                                >
                                                                    Cancel
                                                                </Link>{" "}
                                                                &nbsp; &nbsp;
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                                <ToastContainer />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        );
    }
}
